import React from 'react';
import { cn } from '../../lib/utils';
import Avatar from './Avatar';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  avatar?: {
    src?: string | null;
    alt?: string;
  };
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  avatar,
  className,
}) => {
  return (
    <div
      className={cn(
        'bg-gradient-to-b from-blue-600 to-purple-600 pt-16 pb-8',
        className
      )}
    >
      <div className="container mx-auto px-4 text-center">
        {avatar ? (
          <div className="flex justify-center mb-6">
            <Avatar
              src={avatar.src}
              alt={avatar.alt || 'User'}
              size="xl2"
              className="border-4 border-white/30 shadow-lg"
            />
          </div>
        ) : (
          icon && (
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm border border-white/30">
                <span className="text-3xl">{icon}</span>
              </div>
            </div>
          )
        )}

        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-white">{title}</h1>
          {subtitle && (
            <p className="text-lg text-white/90 max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
